import React from 'react';
import { timeLeftParts, pad } from './auctionUtils';
import { useTranslation } from '../../hooks/useTranslation';

// Ticking clock to `target`. Starts empty and fills on the client so SSR and
// hydration render the same markup. onExpire fires once when the clock
// crosses zero, so the parent can refresh phase without polling on the second.
const Countdown = ({ target, onExpire, className = '' }) => {
  const { locale } = useTranslation('auctions');
  const [parts, setParts] = React.useState(null);
  const expiredRef = React.useRef(false);

  React.useEffect(() => {
    expiredRef.current = false;
    const tick = () => {
      const next = timeLeftParts(target);
      setParts(next);
      if (next.expired && !expiredRef.current) {
        expiredRef.current = true;
        onExpire?.();
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [target]);

  if (!parts) return <span className={`font-mono tabular-nums ${className}`}>—:—:—</span>;

  return (
    <span className={`font-mono tabular-nums ${className}`}>
      {parts.days > 0 && `${parts.days}${locale === 'en' ? 'd' : 'z'} `}
      {pad(parts.hours)}:{pad(parts.minutes)}:{pad(parts.seconds)}
    </span>
  );
};

export default Countdown;
